export class FetchTotalWealth {
  static readonly type = '[TotalWealth] FetchTotalWealth';
  constructor(public currency: string, public enableTotalWealth?: boolean) {}
}

export class UpdateTotalWealthFlag {
  static readonly type = '[TotalWealth] UpdateTotalWealthFlag';
  constructor(public enableTotalWealth: boolean) {}
}
